export enum CommunicationDestination {
  EMPLOYEE = "EMPLOYEE",
  EMPLOYER = "EMPLOYER"
}
